import React, { useEffect, useState } from 'react';
interface CountdownProps {
  className?: string;
}
function pad(n: number): string {
  return String(n).padStart(2, '0');
}
export function Countdown({
  className = ''
}: CountdownProps) {
  // Start at 23h 59m 41s and tick down.
  const [remaining, setRemaining] = useState<number>(23 * 3600 + 59 * 60 + 41);
  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const hrs = Math.floor(remaining / 3600);
  const mins = Math.floor(remaining % 3600 / 60);
  const secs = remaining % 60;
  const units = [{
    value: pad(hrs),
    label: 'hs'
  }, {
    value: pad(mins),
    label: 'min'
  }, {
    value: pad(secs),
    label: 'seg'
  }];
  return <div className={`flex items-center justify-center gap-2 sm:gap-3 ${className}`} data-id="element-84" data-mp="10cl9ed6bvu7a">
      {units.map((u, i) => <React.Fragment key={u.label} data-id="element-85" data-mp="15bog021yi8hd" data-mpi={i}>
          <div className="flex flex-col items-center" data-id="element-86" data-mp="15an2zs1drbx0">
            <span className="font-display text-3xl sm:text-4xl font-bold tabular-nums text-white bg-ink/90 rounded-xl px-3 py-2 min-w-[3.5rem] text-center shadow-lg" data-id="element-87" data-mp="y0n5bzzw5tfu">
              {u.value}
            </span>
            <span className="mt-1 text-[0.65rem] uppercase tracking-widest text-ink/60" data-id="element-88" data-mp="17py8l603k3vt">
              {u.label}
            </span>
          </div>
          {i < units.length - 1 && <span className="font-display text-2xl sm:text-3xl text-rose -mt-4" data-id="element-89" data-mp="f1sngi54scvg">:</span>}
        </React.Fragment>)}
    </div>;
}